import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { selectIsIdle, startSurvey } from 'features/call/call-ui-state/store/';
import { VrsCallCommentsMenuButton } from 'features/call/vrs-call-comments/components';
import {
  isReportNeededSelector,
  setIsReportNeeded,
} from 'features/call/vrs-call-comments/store';

export const VrsCallCommentsRedirectingMenuButton = () => {
  const dispatch = useAppDispatch();
  const isReportNeeded = useAppSelector(isReportNeededSelector);
  const isIdle = useAppSelector(selectIsIdle);
  const toggleReportButton = () => {
    dispatch(setIsReportNeeded(!isReportNeeded));

    if (isIdle) {
      dispatch(startSurvey());
    }
  };

  return (
    <VrsCallCommentsMenuButton
      isChecked={isReportNeeded}
      isDisabled
      onClickHandler={toggleReportButton}
    />
  );
};
